import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // Check screen size on load and resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Check initial screen size
    window.addEventListener('resize', handleResize); // Listen for window resize

    return () => window.removeEventListener('resize', handleResize); // Cleanup
  }, []);

  const handleScrollTo = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.warn(`Element with id ${sectionId} not found`);
    }
  };

  if (isMobile) {
    // Mobile Navbar with Burger Menu
    return (
      <div>
        {/* Burger Menu */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1rem 1.5rem',
            backgroundColor: 'transparent',
          }}
        >
          {/* Logo */}
          <Link
            style={{
              textDecoration: 'none',
              color: 'white',
              fontSize: '1.5rem',
              fontWeight: 'bold',
            }}
            to='/'
          >
            <img src='./assets/primary_logo.png' alt="Logo" height="36px"/>
          </Link>

          {/* Burger Icon */}
          <div
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{
              cursor: 'pointer',
              zIndex: 2000,
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
            }}
          >
            <div
              style={{ width: '25px', height: '3px', background: 'white' }}
            ></div>
            <div
              style={{ width: '25px', height: '3px', background: 'white' }}
            ></div>
            <div
              style={{ width: '25px', height: '3px', background: 'white' }}
            ></div>
          </div>
        </div>

        {/* Fullscreen Menu */}
        {isMenuOpen && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0, 0, 0, 0.95)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
              gap: '2rem',
            }}
          >
            {['Reviews', 'Services', 'Process', 'FAQs'].map((item) => (
              <motion.div
                key={item}
                style={{
                  fontSize: '1.5rem',
                  color: 'white',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  handleScrollTo(item.toLowerCase());
                  setIsMenuOpen(false); // Close menu on click
                }}
                whileHover={{ scale: 1.1 }}
              >
                {item}
              </motion.div>
            ))}

            {/* Call to Action Button */}
            <motion.button
              style={{
                padding: '1rem',
                backgroundColor: '#fd4635',
                color: 'white',
                border: 'none',
                borderRadius: '0.7rem',
                cursor: 'pointer',
                width: 'fit-content',
                fontSize: '1.2rem',
              }}
              whileHover={{
                boxShadow:
                  '0 0 5px #fd4635, 0 0 10px #fd4635, 0 0 15px white, 0 0 20px black',
                transition: { duration: 0.5 },
              }}
              onClick={() => {handleScrollTo('book-call'); setIsMenuOpen(false)}}
              whileTap={{
                scale: 0.9,
                transition: { duration: 0.2 },
              }}
            >
              <Link
                style={{ textDecoration: 'none', color: 'white' }}
              >
                Book a Call
              </Link>
            </motion.button>
          </div>
        )}
      </div>
    );
  }

  // Desktop/Tablet Navbar
  return (
    <div
      style={{
        backgroundColor: 'transparent',
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        top: '1rem',
      }}
    >
      <motion.nav
        style={{
          border: '1px solid #252525',
          maxWidth: 'fit-content',
          display: 'flex',
          padding: '1rem',
          alignItems: 'center',
          borderRadius: '1rem',
          position: 'fixed',
          backdropFilter: 'blur(10px)',
          zIndex: '3',
          gap: '2rem',
        }}
        initial={{ opacity: 0, y: -50 }} // Starting animation
        animate={{ opacity: 1, y: 0 }} // End animation
        transition={{ duration: 0.8 }} // Animation duration
      >
        {/* Logo */}
        <div
          style={{
            color: 'white',
            fontFamily: 'var(--framer-font-family)',
            fontSize: 'var(--framer-font-size)',
            fontWeight: 'var(--framer-font-weight)',
            letterSpacing: 'var(--framer-letter-spacing)',
            lineHeight: 'var(--framer-line-height)',
            flexGrow: 1,
            textAlign: 'center',
          }}
        >
          <Link style={{ textDecoration: 'none', color: 'white' }} to='/'>
            <img src='./assets/primary_logo.png' alt="Logo" height="36px"/>
          </Link>
        </div>

        {/* Navbar Links */}
        <div
          style={{
            listStyle: 'none',
            display: 'flex',
            gap: '2rem',
            margin: 0,
            flexGrow: 2,
            justifyContent: 'center',
          }}
        >
          {['Reviews', 'Services', 'Process', 'FAQs'].map((item) => (
            <span
              key={item}
              style={{
                color: 'white',
                cursor: 'pointer',
                fontFamily: 'var(--framer-font-family)',
                fontSize: 'var(--framer-font-size)',
                fontWeight: 'var(--framer-font-weight)',
                letterSpacing: 'var(--framer-letter-spacing)',
                lineHeight: 'var(--framer-line-height)',
              }}
              onClick={() => handleScrollTo(item.toLowerCase())}
            >
              {item}
            </span>
          ))}
        </div>

        {/* Call to Action Button */}
        <div style={{ width: 'fit-content' }}>
          <motion.button
            style={{
              padding: '0.7rem',
              backgroundColor: '#fd4635',
              position: 'relative',
              left: '0.3rem',
              color: 'white',
              border: 'none',
              borderRadius: '0.7rem',
              cursor: 'pointer',
              fontSize: 'var(--framer-font-size)',
              fontFamily: 'var(--framer-font-family)',
              fontWeight: 'var(--framer-font-weight)',
              letterSpacing: 'var(--framer-letter-spacing)',
              flexGrow: 0.5,
              textAlign: 'center',
            }}
            onClick={() => handleScrollTo('book-call')}
            whileHover={{
              boxShadow:
                '0 0 5px #fd4635, 0 0 10px #fd4635, 0 0 15px white, 0 0 20px black',
              transition: { duration: 0.5 },
            }}
            whileTap={{
              scale: 0.9,
              transition: { duration: 0.2 },
            }}
          >
            <Link
              style={{ textDecoration: 'none', color: 'white' }}
              
            >
              Book a Call
            </Link>
          </motion.button>
        </div>
      </motion.nav>
    </div>
  );
};

export default Navbar;
